<template>
  <div class="page-body space-y-2">
    <p class="h3-title">【B】数字化管理维度</p>
    <p class="font-heiti pt-3">B1 规划管理</p>
    <p>{{info.p_a_1}}</p>
    <p class="text-bold pt-3">——B11 规划实施</p>
    <p>{{info.p_a_2}}</p>
    <p>{{info.p_a_3}}</p>
    <p class="text-bold pt-3">——B12 管理机制</p>
    <p>{{info.p_a_4}}</p>
    <p>{{info.p_a_5}}</p>
    <p class="font-heiti pt-3">B2 要素保障</p>
    <p>{{info.p_a_6}}</p>
    <p class="text-bold pt-3">——B21 人才建设</p>
    <p>{{info.p_a_7}}</p>
    <p>{{info.p_a_8}}</p>
    <p class="text-bold pt-3">——B22 资金保障</p>
    <p>{{info.p_a_9}} </p>
    <p>{{info.p_a_10}}</p>
    <p>{{info.p_a_11}}</p>
    <p>{{info.p_a_12}}</p>
    <p>{{info.p_a_13}}</p>
    <p>{{info.p_a_14}}</p>
  </div>
</template>

<script>
// 数字化管理维度1
export default {
  props: ['info']
}
</script>
